import React, { Component  } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBJumbotron,  MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon, MDBBadge, MDBInput, MDBView, MDBDataTable, MDBCard, MDBCardBody, MDBCardImage, MDBCardTitle, MDBCardText } from "mdbreact";
import Axios from 'axios'
import { Layout, Menu, Breadcrumb, Icon, Select, Input, Button ,Card   } from 'antd';
import { StarOutlined, StarFilled, StarTwoTone, CaretDownOutlined, UserOutlined, RightCircleOutlined, SearchOutlined } from '@ant-design/icons';

import Highlighter from 'react-highlight-words';

import { useReactToPrint } from 'react-to-print';
import jsPDF from 'jspdf';  
import html2canvas from 'html2canvas';  
import Table from '@material-ui/core/Table';  
import { CSVLink, CSVDownload } from "react-csv";
import ReactExport from "react-export-excel";
import ModelDescription from './ModelDescription';
import { api, URL } from '../../api';
import ModelRegister from './ModelRegister';



//import Modaladdcurriculumopen from './Modaladdcurriculumopen';
//import Modeltest from './Modeltest';
//import Modaladdteacher from './Modaladdteacher';



export default class Studentmain extends Component {
    
    constructor(props) {
        super(props);
        this.state = {

          modal: false,
         
          type:'1',
        
          year:'2564',
          search: '',

          Curriculum:[],
          Studentcb_ID:'',
          Citizen:'',





        
          Course_ID:'',
          Course_Name_TH:'',
          Course_Name_En:'',
          Course_Credit:'',
          Course_Year:'',
          Course_T_Hour:'',
          Course_Detail_TH:'',
          Course_Detail_EN:'',

          pagination: {
            current: 1,
            pageSize: 20,
          },

        };
       
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onSearch = this.onSearch.bind(this);

      
        this.time = this.time.bind(this);
        this.sentpdf = this.sentpdf.bind(this);
       
        this.refreshPage = this.refreshPage.bind(this);
        this.onChange = this.onChange.bind(this);


        this.getCurriculumopen = this.getCurriculumopen.bind(this);
        this.getCitizenstu = this.getCitizenstu.bind(this);
      
        
      }


      onChange(value) {
        
           const Courseselect = this.state.Course.filter( ({ Course_ID }) => Course_ID.substring(0, 7) === value.substring(0, 7) );
         //  const idemp = value; Curriculumopen_Mook
         //  console.log(Courseselect[0].Course_ID);
           this.setState({ Course_ID : Courseselect[0].Course_ID.substring(0, 7) });
           this.setState({ Course_Name_TH : Courseselect[0].Course_Name_TH });
           this.setState({ Course_Name_En : Courseselect[0].Course_Name_En });
           this.setState({ Course_Credit : Courseselect[0].Course_Credit });
           this.setState({ Course_Year : Courseselect[0].Course_Year });
           this.setState({ Course_T_Hour : Courseselect[0].Course_T_Hour });
           this.setState({ Course_Detail_TH : Courseselect[0].Course_Detail_TH });
           this.setState({ Course_Detail_EN : Courseselect[0].Course_Detail_EN });

           this.getCurriculumopen()

        }

        //ดึงหลักสูตรที่เปิดสอน
        getCurriculumopen() {
          setTimeout(() => {
             //ภายใน
             api.get('index/getCurriculumopen/'+this.state.Course_ID)
             .then(res => {
             //  console.log(res);
             //  this.setState({ bankname: res.data, loading: false })
               this.setState({ Curriculumopen: res.data})
             }) 
           }, 0);
      }

      getCitizenstu() {
        setTimeout(() => {
           //ภายใน
           api.get('index/getCitizenstu/'+localStorage.getItem('Studentcb_ID'))
           .then(res => {
           //  console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ Citizen: res.data[0].Studentcb_Citizen_ID})
           }) 
         }, 0);
    }


      sentpdf() {
        setTimeout(() => {
          window.open('https://e-student.kpru.ac.th/vaccinekpru/vaccinepdf/report/tess.php?stu='+this.state.major+'', '_blank');
           // window.location.href ='http://localhost/tesspdf/TCPDF-main/tess.php?term='+this.state.term+'&idemp='+this.state.idemp 
         }, 0);
      }

 

         onBlur() {
            console.log('blur');
          }
          
           onFocus() {
            console.log('focus');
          }
          
           onSearch(val) {
            console.log('search:', val);
          }

          time() {
            const d = new Date();
            d.setMinutes(17);
            document.getElementById("demo").innerHTML = d;
          }

          refreshPage() {
            window.location.reload(false);
          }




          componentDidMount(){
           
            this.setState({ Studentcb_ID:localStorage.getItem('Studentcb_ID')}) 

            if (localStorage.getItem('name') == null) {
               
                  window.location.href = '/creditbank/Studentmain'
               
            } else {
        
            }
                      api.get('index/getCurriculumopenall2',
                   //     Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
                      {headers: {
                        // Authorization: 'Bearer ' + localStorage.getItem('myData')
                      }
                      })
                      //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
                      .then(res => {
                         // console.log(res.data[0].id)
                       //  console.log(res.data)
                      //   const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
                       //  console.log(Course)
                          const Curriculum = res.data;
                          this.setState({ Curriculum });
                      })    
                this.getCitizenstu()  ;   
          }


          getColumnSearchProps = dataIndex => ({
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters , filters}) => (
              <div style={{ padding: 8 }}>
                <Input
                  ref={node => {
                    this.searchInput = node;
                  }}
                  placeholder={`ค้นหา`}
                  value={selectedKeys[0]}
                  onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                  onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                  style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                  type="primary"
                  onClick={() => this.handleSearch(selectedKeys, confirm)}
                  icon=""
                  size="small"
                  style={{ width: 90, marginRight: 8 }}
                >
                  ค้นหา
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                  ยกเลิก
                </Button>
              </div>
            ),
            filterIcon: filtered => (
              <SearchOutlined />
            ),
        
            onFilter: (value, record) =>
              record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => this.searchInput.select());
              }
            },
        
            
            render: text => (
              <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[this.state.searchText]}
                autoEscape
                textToHighlight={text.toString()}
              />
            ),
          });
        
          handleSearch = (selectedKeys, confirm) => {
            confirm();
            this.setState({ searchText: selectedKeys[0] });
          };
        
          handleReset = clearFilters => {
            clearFilters();
            this.setState({ searchText: '' });
          };
                
          clearFilters = () => {
            this.setState({ filteredInfo: null });
          };
        
        
          clearAll = () => {
            this.setState({
              filteredInfo: null,
              sortedInfo: null,
            });
          };




       


    render() {

      console.log(this.state.Course_ID)
      let { sortedInfo, filteredInfo } = this.state;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};
      const {  pagination } = this.state;
     
   
      const { Option } = Select;

      const date = new Date();
      const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
      const dates = year+"-"+month+"-"+day ;
      console.log(dates);






      // ตารางแสดงข้อมูล
    
 
      const data = {
        columns: [
          {
            label: '#',
            field: 'list',
            sort: 'list',
            width: 150,
          },
          {
            label: 'ปี',
            field: 'Course_YEAR',
            sort: 'Course_YEAR',
            width: 150
          },
          {
            label: 'ภาคเรียน',
            field: 'Curriculumopen_TEAM',
            sort: 'Curriculumopen_TEAM',
            width: 270
          },
          {
            label: 'รหัสวิชา',
            field: 'Course_ID',
            sort: 'Course_ID',
            width: 270
          },
          {
            label: 'ชื่อหลักสูตรภาษาไทย',
            field: 'Curriculumopen_Full_Name_TH',
            sort: 'Curriculumopen_Full_Name_TH',
            width: 200
          },
          {
            label: 'ชื่อหลักสูตรภาษาอังกฤษ',
            field: 'Curriculumopen_Full_Name_EN',
            sort: 'Curriculumopen_Full_Name_EN',
            width: 100
          },
          {
            label: 'จำนวนชั่วโมง',
            field: 'Curriculumopen_CH',
            sort: 'Curriculumopen_CH',
            width: 150
          },
          {
            label: 'วันเริ่ม',
            field: 'Curriculumopen_Date_START',
            sort: 'Curriculumopen_Date_START',
            width: 150
          },
          {
            label: 'วันสิ้นสุด',
            field: 'Curriculumopen_Date_END',
            sort: 'Curriculumopen_Date_END',
            width: 150
          },
          {
            label: 'จำนวนรับ',
            field: 'NUMID',
            sort: 'NUMID',
            width: 150
          },
          {
            label: 'เปิดสอนใน KPRU MOOK',
            field: 'Mook',
            sort: 'Mook',
            width: 150
          },
         
          {
            label: 'ลงทะเบียน',
            field: 'Curriculumopen_EDIT',
            sort: 'Curriculumopen_EDIT',
            width: 150
          }


        ],

        rows: [...this.state.Curriculum.map((data, i) => (
          {
             list: <>{i+1}</>,
             Course_YEAR: <>{data.Course_YEAR}</>,
             Curriculumopen_TEAM: <>{data.Curriculumopen_TEAM}</>,
             Course_ID : <>{data.Course_ID	}</>,
             Curriculumopen_Full_Name_TH: <>{data.Curriculumopen_Full_Name_TH}</>,
             Curriculumopen_Full_Name_EN: <>{data.Curriculumopen_Full_Name_EN}</>,
             Curriculumopen_CH: <>{data.Curriculumopen_CH}</>,
             Curriculumopen_Date_START: <>{data.Curriculumopen_Date_START}</>,
             Curriculumopen_Date_END: <>{data.Curriculumopen_Date_END}</>,
             NUMID: <> จำนวนที่รับ {data.NUMID} / {data.Curriculumopen_NUM} </>,
             Mook: <> {data.Curriculumopen_Mook === "1" ?<>
              <p>มีสอนใน KPRU MOOC</p>
              </>:<>
              <p>ไม่มีสอนใน KPRU MOOC</p>
              </>} </>,
           
             Curriculumopen_EDIT: <>  { Number(data.NUMID)  >= Number(data.Curriculumopen_NUM)  ? <>

              <MDBBtn color="dark-green">ลงทะเบียนเต็มแล้ว</MDBBtn>
              </>:<><ModelRegister Curriculumopen_ID = {data.Curriculumopen_ID} Studentcb_ID ={this.state.Studentcb_ID} Citizen={this.state.Citizen} /> </> } </>,


             random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,
            

          }
         ))]
        
    
    };

    const persons = <MDBDataTable 
   // searching ={true}
    searchLabel="ค้นหา ชื่อหลักสูตร"
    striped
    bordered
    small 
    entries={20}
   // entriesOptions={["10", "20"]}
    order={["age", "desc"]}
    data={data}
    entriesLabel="จำนวนที่แสดง "
    infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
    paginationLabel={["ย้อนกลับ", "ถัดไป"]}
    responsive 
    sortRows={['random']}
    />

       
        return (
            <MDBContainer fluid>
                {/* <MDBAlert color="primary" >
                <h4><MDBIcon icon="address-book" className="indigo-text pr-3" /> ตารางเรียน </h4>
                </MDBAlert>
                <br/> */}
    
{/* <CSVLink data={data}>Download EXCEL</CSVLink> */}
       <Card type="inner" style={{ marginTop: 16 }}  title={<h4><MDBIcon icon="list-alt" /> ลงทะเบียนเรียน หลักสูตร/วิชาที่เปิดสอนใน KPRU MOOC</h4> } extra={<a href="#"><p>คุณ{localStorage.getItem('name')}</p></a>} >

            {/* <MDBRow>
                    <MDBCol sm="6">
                ค้นหารายวิชา  
                    <Select
                            showSearch
                            style={{ width: 300 }}
                            placeholder="เลือกวิชา"
                            optionFilterProp="children"
                            onChange={this.onChange}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                            onSearch={this.onSearch}
                            filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                          
                        
                        {this.state.Curriculum.map((Curriculum,index )  => 
                        <option value={Curriculum.Curriculumopen_ID}>{Curriculum.Curriculumopen_Full_Name_TH}</option>
                        )}
                        </Select>
                    </MDBCol>

                    <MDBCol sm="4">
                        <div>
                       
                        </div>
                          
                    </MDBCol> 
            </MDBRow> */}

            <br/>

          
                 <MDBRow>
                        <MDBCol sm="12">
                            
                            <MDBJumbotron fluid>
                            <MDBContainer fluid>
                            <h2 className="display-5 deep-purple-text text-center">วิชาที่เปิดสอนใน KPRU MOOC</h2>
                                {/* <h4 className="display-5 deep-purple-text">รายละเอียดวิชา</h4> */}
                                <MDBCol>
                                {persons}
                                {/* {this.state.Curriculum.map((Curriculum,index) => { 

                                return  <MDBCard style={{ width: "100%", marginTop: "1rem" }}>
                                          
                                            <MDBCardBody>
                                              
                                            <MDBRow>
                                              <MDBCol size="8">
                                                 <MDBCardTitle>หลักสุตร {Curriculum.Curriculumopen_Full_Name_TH}</MDBCardTitle>
                                                  <MDBCardText>
                                                  ชื่อหลักสุตรภาษาอังกฤษ : {Curriculum.Curriculumopen_Full_Name_TH} | จำนวน: {Curriculum.Curriculumopen_CH}  ชั่วโมง  | จำนวนที่รับ {Curriculum.NUMID} / {Curriculum.Curriculumopen_NUM} 
                                                  </MDBCardText>
                                              </MDBCol>
                                              <MDBCol size="4" className="text-center">
                                                {Curriculum.Curriculumopen_Date_ENDRE < dates ? <>  <MDBAlert color="success" > ปิดรับลงทะเบียน </MDBAlert></>:
                                                <>
                                                  { Number(Curriculum.NUMID)  >= Number(Curriculum.Curriculumopen_NUM)  ? <>
                                                 <MDBBtn color="dark-green">ลงทะเบียนเต็มแล้ว</MDBBtn>
                                                 </>:<><ModelRegister Curriculumopen_ID = {Curriculum.Curriculumopen_ID} Studentcb_ID ={this.state.Studentcb_ID} Citizen={this.state.Citizen} /> </> } <ModelDescription Curriculumopen_ID = {Curriculum.Curriculumopen_ID} />
                                                 </> }
                                              
                                              </MDBCol>
                                            </MDBRow>

                                                          
                                            </MDBCardBody>
                                        </MDBCard> 
                                      
                                })}   */}


 


                                </MDBCol>
                            </MDBContainer>
                            </MDBJumbotron>    
                      
                        </MDBCol>
                 </MDBRow>

          
            <br/>
            <MDBRow>
                        <MDBCol sm="12">
                            {this.state.Course_ID != '' ? <>
                            <MDBJumbotron fluid>
                                <MDBContainer>
                                <h2 className="display-5 deep-purple-text text-center">นักศึกษา {this.state.Course_Name_TH}</h2>
                                    <h4 className="display-5 deep-purple-text">รายละเอียดวิชา</h4>
                                    {/* <p className="lead">This is a modified jumbotron that occupies the entire horizontal space of its parent.</p> */}
                                    {/* <MDBTable bordered responsiveMd>
                                    <MDBTableHead>
                                    <tr>
                                        <th>รหัสวิชา</th>
                                        <th>ชื่อวิชาภาษาไทย</th>
                                        <th>ชื่อวิชาภาษาอังกฤษ</th>
                                        <th>หน่วยกิต</th>
                                        <th>ปี</th>
                                        <th>จำนวนชั่วโมง</th>
                                        <th>คำอธิบายรายวิชาภาษาไทย</th>
                                        <th>คำอธิบายรายวิชาภาษาอังกฤษ</th>
                                    </tr>
                                    </MDBTableHead>
                                    <MDBTableBody>

                                        <tr>
                                        <td>{this.state.Course_ID}</td>
                                        <td>{this.state.Course_Name_TH}</td>
                                        <td>{this.state.Course_Name_En}</td>
                                        <td>{this.state.Course_Credit}</td>
                                        <td>{this.state.Course_Year}</td>
                                        <td>{this.state.Course_T_Hour}</td>
                                        <td>{this.state.Course_Detail_TH}</td>
                                        <td>{this.state.Course_Detail_EN}</td>
                                        </tr>

                                    </MDBTableBody>
                                    </MDBTable> */}
                                </MDBContainer>
                                </MDBJumbotron>
                            </>:<></>}
                    
                    
                        </MDBCol>

                        {/* <MDBCol sm="7">
                    
                        </MDBCol>  */}
            </MDBRow>

     <MDBRow>
          <MDBCol sm="12">
          {this.state.Course_ID != '' ? <>
                      <MDBJumbotron fluid>
                        <MDBContainer>
                            <h4 className="display-5 deep-purple-text">ข้อมูลหลักสูตรระยะสั้น </h4>
                            {/* <p className="lead">This is a modified jumbotron that occupies the entire horizontal space of its parent.</p> */}
                            {/* <Table id="pdfdiv" columns={columns} dataSource={this.state.Curriculumopen} onChange={this.handleChange} responsive scroll={{ x: 1000 }}  pagination={{ pagination, showSizeChanger: true}}   />     */}
                            {/* <MDBTable small responsiveMd>
                                <MDBTableHead>
                                    <tr>
                                    <th>#</th>
                                    <th>ปี</th>
                                    <th>เทอม</th>
                                    <th>ชื่อหลักสูตรภาษาไทย</th>
                                    <th>ชื่อหลักสูตรภาษาอังกฤษ</th>
                                    <th>จำนวนชั่วโมง</th>
                                    <th>วันเริ่ม</th>
                                    <th>วันสิ้นสุด</th>
                                    <th>จัดการผู้สอน</th>
                                    </tr>
                                </MDBTableHead>

                                <MDBTableBody>
                                {this.state.Curriculumopen.map((Curriculumopen,index) => {
                                  return  <tr>
                                    <td>{index+1}</td>
                                    <td>{Curriculumopen.Course_YEAR }</td>
                                    <td>{Curriculumopen.Curriculumopen_TEAM }</td>
                                    <td>{Curriculumopen.Curriculumopen_Full_Name_TH }</td>
                                    <td>{Curriculumopen.Curriculumopen_Full_Name_EN }</td>
                                    <td>{Curriculumopen.Curriculumopen_CH }</td>
                                    <td>{Curriculumopen.Curriculumopen_Date_START }</td>
                                    <td>{Curriculumopen.Curriculumopen_Date_END }</td>
                                    <td><Modaladdteacher Curriculumopen_ID={Curriculumopen.Curriculumopen_ID } Curriculumopen_Full_Name_TH={Curriculumopen.Curriculumopen_Full_Name_TH} Univ_ID={Curriculumopen.Univ_ID} /></td>
                                    </tr>
                                   })}  
                                </MDBTableBody>
                            </MDBTable> */}

                        </MDBContainer>
                        </MDBJumbotron>
                    </>:<></>}       
          </MDBCol>
     </MDBRow>

        </Card>

       
            </MDBContainer>
        )
    }
}
